module.exports = "https://static.wanderu.com/ui-react/_next/static/media/usa-today-x2.1b7130b3.png";